"use client";

import React, { createContext, useContext, useState, useEffect } from "react";
import { usePathname } from "next/navigation";

type MobileNavContextType = {
    isOpen: boolean;
    toggle: () => void;
    close: () => void;
};

const MobileNavContext = createContext<MobileNavContextType | undefined>(undefined);

export function MobileNavProvider({ children }: { children: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const pathname = usePathname();

    // Close sidebar on route change
    useEffect(() => {
        setIsOpen(false);
    }, [pathname]);

    return (
        <MobileNavContext.Provider value={{ isOpen, toggle: () => setIsOpen(prev => !prev), close: () => setIsOpen(false) }}>
            {children}
        </MobileNavContext.Provider>
    );
}

export const useMobileNav = () => {
    const context = useContext(MobileNavContext);
    if (!context) throw new Error("useMobileNav must be used within MobileNavProvider");
    return context;
};
